export default __webpack_public_path__ + "static/media/icn-deposit-off.db316075.svg";